import { render } from "./EmptyLayoutWithHeader.vue?vue&type=template&id=9731ef3a&scoped=true&lang=pug"
const script = {}

import "./EmptyLayoutWithHeader.vue?vue&type=style&index=0&id=9731ef3a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9731ef3a"]])

export default __exports__